
export const CardServiceDefaults = {
    actionsThreshold: 100,
};
